/* ISC License (ISC). Copyright 2017 Michal Zalecki */
// https://michalzalecki.com/why-using-localStorage-directly-is-a-bad-idea/

const storageFactory = getStorage => {
  let inMemoryStorage = {};

  // If the storage type passed in is not supported, proceed to try and use an in memory storage.
  // In all honesty, storage cache is only used to improve user experience and to get to this point the user would have to manually block all caching for our site.
  // The user just won't stay logged in if they turned it off.
  const isSupported = () => {
    try {
      const testKey = "__zhuper_key__";
      getStorage().setItem(testKey, testKey);
      getStorage().removeItem(testKey);
      return true;
    } catch (e) {
      return false;
    }
  };

  const clear = () => {
    if (isSupported()) {
      getStorage().clear();
    } else {
      inMemoryStorage = {};
    }
  };

  const getItem = name => {
    if (isSupported()) {
      return getStorage().getItem(name);
    }
    if (inMemoryStorage.hasOwnProperty(name)) {
      return inMemoryStorage[name];
    }
    return null;
  };

  const key = index => {
    if (isSupported()) {
      return getStorage().key(index);
    } else {
      return Object.keys(inMemoryStorage)[index] || null;
    }
  };

  const removeItem = name => {
    if (isSupported()) {
      getStorage().removeItem(name);
    } else {
      delete inMemoryStorage[name];
    }
  };

  const setItem = (name, value) => {
    if (isSupported()) {
      getStorage().setItem(name, value);
    } else {
      inMemoryStorage[name] = String(value);
    }
  };

  const length = () => {
    if (isSupported()) {
      return getStorage().length;
    } else {
      return Object.keys(inMemoryStorage).length;
    }
  };

  return {
    getItem,
    setItem,
    removeItem,
    clear,
    key,
    get length() {
      return length();
    },
  };
};

export default storageFactory;
